export default [
  {
    title: '直播间',
    name: 'lecturerLive'
  }
  ]
  


// WEBPACK FOOTER //
// ./src/route/liveRouter.js